import React, { useEffect, useRef } from "react";

const Congresillo = ({ roomName, usuario, setDialogCongresillo, scriptRef }) => {
  const jitsiContainerRef = useRef(null);
  const apiRef = useRef(null);
  const initializedRef = useRef(false); // 🔥 clave

  useEffect(() => {
    if (initializedRef.current) return; // evita doble ejecución
    initializedRef.current = true;

    const loadScript = () => {
      return new Promise((resolve) => {
        if(scriptRef.current) return resolve(true);
      });
    };

    loadScript().then(() => {
      const domain = "jitsi.prowebsports.com.co";

      const options = {
        roomName,
        width: "100%",
        height: "600px",
        parentNode: jitsiContainerRef.current,
        userInfo: {
          displayName: usuario.nombreclub || "Usuario",
          avatarURL: usuario.photo,
          moderator: false
        },
        configOverwrite: {
          disableDeepLinking: true,
          disableInviteFunctions: true,
          prejoinPageEnabled: false,
        },
        interfaceConfigOverwrite: {
          TOOLBAR_BUTTONS: [
            "microphone",
            "camera",
            "closedcaptions",
            "desktop",
            "fullscreen",
            "fodeviceselection",
            "hangup",
            "profile",
            "chat",
            "recording",
            "livestreaming",
            "etherpad",
            "sharedvideo",
            "settings",
            "raisehand",
            "videoquality",
            "filmstrip",
            "stats",
            "shortcuts",
            "tileview",
            "download",
            "help",
            "mute-everyone",
            "security"
          ],
        },
      };

      apiRef.current = new window.JitsiMeetExternalAPI(domain, options);
      // ✅ detectar salida
      apiRef.current.addEventListener("readyToClose", () => {
        if (apiRef.current) {
          apiRef.current.dispose();
          apiRef.current = null; // 🔥 CLAVE
        }
      
        setDialogCongresillo(false);
      });
    })

    return () => {
      if (apiRef.current) {
        apiRef.current.dispose();
        apiRef.current = null;
      }
    };
  }, []);

  return (
    <div
      ref={jitsiContainerRef}
      style={{ width: "100%", height: "600px" }}
    />
  );
};

export default Congresillo;